import * as React from 'react'
import { Route, Routes } from 'react-router-dom'
import { ErrorBoundary } from '@/modules/shared/components/ErrorBoundary'
import { ErrorFallback } from '@/modules/shared/components/ErrorFallback'
import { AppLayoutDahboardWithNav } from '@/modules/shared/layouts/AppLayoutDahboardWithNav'
import { toRelativeRoute, wrapRoutesWithRouter } from '@/modules/shared/utils/routerPaths'
import { PermissionGuard } from '@/modules/shared/components/NoPermission'
import { moduleAccess } from '@/modules/shared/permissions'

const wrappedDatabasesRoutes = wrapRoutesWithRouter(databasesRoutes)
import { databasesRoutes } from './routes'
import { databasesPath } from './index'

const DatabasesModuleImpl: React.FC = () => {
  return (
    <ErrorBoundary fallback={<ErrorFallback />}>
          <AppLayoutDahboardWithNav>
            <PermissionGuard {...moduleAccess.databases}>
              <div className="module-databases tw-padding-4 tw-mt-1 tw-mb-1 tw-flex tw-flex-[1] tw-flex-col tw-min-w-0 tw-max-w-full tw-min-h-[calc(100vh-8px)] tw-overflow-y-hidden tw-rounded-xl tw-border tw-border-base-300 tw-bg-base-100 tw-text-content-base">
                <ErrorBoundary fallback={(e) => <ErrorFallback error={e.error} onRetry={e.reset} />}>
                  <Routes>
                    {wrappedDatabasesRoutes.map((route) => (
                          <Route
                          key={route.path}
                          path={`${toRelativeRoute(route.path, databasesPath)}/*`}
                          element={<route.Component />}
                        />
                        ))}
                  </Routes>
                </ErrorBoundary>
              </div>
            </PermissionGuard>
          </AppLayoutDahboardWithNav>
    </ErrorBoundary>
  )
}

export const DatabasesModule = DatabasesModuleImpl
